import React from "react";
import { translate } from "react-i18next";
import colors from "../../../../styles/colors";

import { Container, SatisfactionLabel } from "./styles";
import { Input } from "../../../../styles/defaults";

function Satisfaction({ t, response, onValueChange, onClick, guid, questionIndexToModel }) {
  return (
    <Container>
      <Input
        type="radio"
        name="satisfaction"
        id={`satisfacted-${questionIndexToModel}-${guid}`}
        value={1}
        onChange={({ target }) =>
          onValueChange({ response: parseInt(target.value) })
        }
        onClick={({ target }) => onClick(target.value)}
      />
      <SatisfactionLabel
        checked={parseInt(response) === 1}
        selected={response}
        bgColor={colors.positive}
        htmlFor={`satisfacted-${questionIndexToModel}-${guid}`}
      >
        {t("imSatisfied")}
      </SatisfactionLabel>

      <Input
        type="radio"
        name="satisfaction"
        id={`unsatisfacted-${questionIndexToModel}-${guid}`}
        value={2}
        onChange={({ target }) =>
          onValueChange({ response: parseInt(target.value) })
        }
        onClick={({ target }) => onClick(target.value)}
      />
      <SatisfactionLabel
        checked={parseInt(response) === 2}
        selected={response}
        bgColor={colors.negative}
        htmlFor={`unsatisfacted-${questionIndexToModel}-${guid}`}
      >
        {t("imDissatisfied")}
      </SatisfactionLabel>
    </Container>
  );
}

export default translate("translations")(Satisfaction);
